<template>
    <div class="embed-segment">
        <client-only>
            <component v-if="embedType" :is="embedType.component" :url="segmentData.url" :title="segmentData.title" :caption="segmentData.caption" />
        </client-only>
    </div>
</template>

<script>
import Tweet from "~/components/Tweet";
import Youtube from "~/components/Youtube";

const embedMap = [
    {
        pattern: /^.*?twitter.com\/.*\/status\/([a-z0-9]*).*?$/i,
        component: Tweet,
    },
    {
        pattern: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/i,
        component: Youtube,
    },
];

export default {
    components: {},

    props: {
        id: String,
        segmentData: Object,
    },

    computed: {
        embedType() {
            if (!this.segmentData.url) return null;
            return embedMap.find((embed) => embed.pattern.test(this.segmentData.url)) ?? null;
        },
    },
};
</script>
